import { render, staticRenderFns } from "./BuyingRules..vue?vue&type=template&id=60c04f98&"
import script from "./BuyingRules..vue?vue&type=script&lang=js&"
export * from "./BuyingRules..vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports